/**
 * Formats a string and replaces the parameters with the
 * args
 *
 * @example
 * format("{0} is dead, but {1} is alive! {0} {2}", ["ASP", "ASP.NET"])
 *
 * @param {string} text string that will have the strings replaced into
 * @param  {string[]} args array of strings
 * @returns {string} replaced string
 */
export const format = (text, args) =>
  text?.replace(/{(\d+)}/g, (match, number) =>
    typeof args[number] !== 'undefined' ? args[number] : match,
  );

export const capitalize = (str) =>
  str?.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

export const pluralize = (count, noun, suffix = 's') =>
  `${count} ${noun}${count !== 1 ? suffix : ''}`;
